import { mockOverrides as localMockOverrides } from './local/mockOverrides';
import { resolverOverrides as localResolverOverrides } from './local/resolverOverrides';
import { mockOverrides as testMockOverrides } from './test/mockOverrides';
import { resolverOverrides as testResolverOverrides } from './test/resolverOverrides';

export const testGraphqlMocks = () => ({
  mockOverrides: testMockOverrides,
  resolverOverrides: testResolverOverrides,
});

export const localGraphqlMocks = () => ({
  mockOverrides: localMockOverrides,
  resolverOverrides: localResolverOverrides,
});
